import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContractVolumeAttachments } from 'src/app/Finance/Models/contract-volume';
import { LoaderService } from 'src/app/Loader/loader.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { AuditIdentifier, AuditLogEntities, AuditLogModule, AuditOperations, CodeList, CodeListStatusTypes, Dateformat, FileExtension, StatusCodes } from 'src/app/shared/constants/global.constants';
import { AuditLogService } from 'src/app/shared/ModelComparison/audit.log.service';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FileUploadService } from 'src/app/Engagement/Services/fileupload.service';
import { DatePipe, formatDate } from '@angular/common';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { start } from 'repl';
import { FuzzyMatchService } from 'src/app/Reusable/fuzzy-match.service';
import { asecDependencies } from 'mathjs';
@Component({
  selector: 'app-con-volume-edit',
  templateUrl: './con-volume-edit.component.html',
  styleUrls: ['./con-volume-edit.component.css']
})
export class ConVolumeEditComponent implements OnInit {

  @Output() editButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelVolumeButtonClick = new EventEmitter<void>();
  @Output() saveVolumeButtonClick = new EventEmitter<void>();
  @Output() viewButtonClick: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('fileInput') fileInput!: ElementRef;

  @Input() contractId: any;
  @Input() contractName: any;
  @Input() volumeId: any;
  @Input() SupplierId: any;
  @Input() SponsorId: any;
  @Input() EngagementName: any;
  @Input() Currency: any;
  @Input() productApplicability : any;
  @ViewChild('dt') table: any;

  selectedMonth = '';
  data: any[] = []

  listOfVolumes: any[] = [];
  uploadedFiles: File[] = [];
  statusList: any = [];
  volumeDetail: any = {};
  uploadedForecastFile: any;
  newAttachment: any;
  _contractVolumeAttachmentsDetails: any[] = [];
  _contractVolumeProductsDetails: any[] = [];
  uploadedFileNames: string = "";
  isUploadButtonDisabled: boolean = false;
  _contractVolumeAttachments = new ContractVolumeAttachments();
  multiVolumeFileData: any[] = [];
  formData = new FormData();
  volumeForm: FormGroup;
  volumeSubmitted: Boolean = false;
  mode: 'Upload' | 'Manual' = 'Upload';
  distributionMode: 'Equal' | 'Manual' = 'Manual';

  searchText: string = '';
  searchTerm: string = '';
  isOverrideEnabled: Boolean = false;

  constructor(private fb: FormBuilder, private tabAndStateService: TabAndStateService, private auditLogService: AuditLogService, private privilegeService: PrivilegeService,
    private loaderService: LoaderService, private masterDataService: SponserService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private _fileService: FileUploadService, private datePipe: DatePipe, private financeService: FinanceService, private fuzzyMatchService: FuzzyMatchService
  ) {
    this.volumeForm = this.fb.group({
      productApplicable: [null],
      entryMethod: [null],
      _volumeAmount: ['', [Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _volumeFile: [''],
      _volumeFileName: '',
      _volumeAttachments: [''],

    });
  }

  auditIdentifierDetails: any;
  auditEntities: any;
  auditOperations: any;
  auditModule: any;
  _dateformart: any;
  currentIndex: number = -1;
  updatedBy: any;
  createdBy: any;
  volumeDetailOld: any;
  changedContractVolumeBasicInfo: any;
  oldContractVolumeData: any;
  contractVolumeDetailBeforeUpdate: any
  codeListStatusTypes: any;
  codeListValues: any;
  statusCodes: any;
  statusData: any;
  StatusName: any[] = [];
  status: any;
  masterProducts: any[] = [];
  manualTableData: any[] = [];
  filteredProducts: any[] = [];
  totalAllocatedPercentage: number = 0;
  totalInvoice: number = 0;
  isProcessClicked: Boolean = false;
  totalOverridePercentage: number = 0;
  async ngOnInit(): Promise<void> {

    this.loaderService.showLoader();
    this.codeListValues = CodeList;
    this.codeListStatusTypes = CodeListStatusTypes;
      this.GetsponserStatus();
   this.statusCodes = StatusCodes;
   await this.GetVolumeStatus(this.codeListValues.Tbl_Status, this.codeListStatusTypes.VOLSTS);
   setTimeout(() => {
     this.GetProductMasterList();
   }, 1500);
  
    setTimeout(() => {
       this.BindData(this.volumeId)
    }, 2000);
   
    this.auditEntities = AuditLogEntities;
    this.auditOperations = AuditOperations;
    this.auditModule = AuditLogModule;
    this._dateformart = Dateformat;
    this.listOfVolumes = this.tabAndStateService.getVolumeData();
    setTimeout(() => {
       if (this.listOfVolumes && this.volumeDetail && this.volumeDetail.volumeDate) {
  this.currentIndex = this.listOfVolumes.findIndex((a: { volumeDate: any }) => a.volumeDate == this.volumeDetail.volumeDate);
      }
       this.loaderService.hideLoader();
    }, 3000);


  }
  async GetVolumeStatus(enumId: number, type: string):Promise<void> {
    this.masterDataService.getCodeListData(enumId, type).subscribe(
      res => {
        if (res.data.length > 0) {
          this.statusData = res.data;
        }
      });
  };


  getStatusName(statusId: number): string {
    this.status = this.statusData.find((s: { id: number; }) => s.id === statusId);
    return this.status ? this.status.name : 'Unknown';
  }

BindData(data: any) {
 if (data.productApplicability == null) {
    data.productApplicability = this.productApplicability;
  }
  
   if (data.invoiceAmount === null && data.InvoiceValue) {
    const numericValue = parseFloat(data.InvoiceValue.replace(/[$,]/g, ''));
    data.invoiceAmount = numericValue;
  }
  this.volumeDetail = data;
  this.contractDetailId = data.contractDetailId;

  const productApplicableValue = data.productApplicability === true || data.productApplicability === 'true';

  const entryMethodValue = data.dataEntry === true ? 'Upload' : 'Manual';

  this.volumeForm.patchValue({
    productApplicable: productApplicableValue,
    entryMethod: entryMethodValue
  });
this.productApplicability = productApplicableValue;
  this.mode = entryMethodValue;
  this.distributionMode = entryMethodValue === 'Upload' ? 'Equal' : 'Manual';


  if (!this.volumeDetail.statusMappingId && this.volumeDetail.statusName) {

    const matchedStatus = this.statusData.find(
      (x: { name: any }) => x.name === this.volumeDetail.statusName
    );

    if (matchedStatus) {
      this.volumeDetail.statusMappingId = matchedStatus.id;
    }

  }

  this.totalInvoice = data?.invoiceAmount || 0;


  if (data.financeContractVolumeAttachments &&
      data.financeContractVolumeAttachments.length > 0) {

    this._contractVolumeAttachments.Id =
      data.financeContractVolumeAttachments[0].id;

    this._contractVolumeAttachmentsDetails =
      data.financeContractVolumeAttachments;

    this.uploadedFiles =
      data.financeContractVolumeAttachments.map(
        (attachment: { fileName: any }) => {

          return new File(
            [attachment.fileName],
            attachment.fileName
          );

        });

    this.uploadedFileNames =
      this.uploadedFiles.map(file => file.name).join(', ');

    if (this.uploadedFiles.length >= 20) {
      this.isUploadButtonDisabled = true;
    } else {
      this.isUploadButtonDisabled = false;
    }
  }

  if (this.volumeDetail.id != 0) {
    if (this.volumeDetail?.updatedBy == null)
    this.volumeDetail.contractDetailId = this.contractId;

    this.updatedBy =
      this.privilegeService.getUserName(this.volumeDetail.updatedBy);

    this.createdBy =
      this.privilegeService.getUserName(this.volumeDetail.createdBy);

  }
  else {
    this.volumeDetail.contractDetailId = this.contractId;
  }


  this.auditIdentifierDetails = AuditIdentifier;

  this.volumeDetailOld =
    JSON.stringify(this.volumeDetail);

  this.oldContractVolumeData =
    JSON.stringify(this.volumeDetail);

  this.contractVolumeDetailBeforeUpdate =
    JSON.stringify(this.volumeDetail);

}

  navigateTo(index: number): void {

  if (!this.listOfVolumes || this.listOfVolumes.length === 0) {
    this.currentIndex = 0;
    return;
  }

  let newIndex = index;

  if (index > this.currentIndex) {
    while (
      newIndex < this.listOfVolumes.length &&
      this.listOfVolumes[newIndex]?.InvoiceValue == null || this.listOfVolumes[newIndex]?.statusName === 'Complete' || this.listOfVolumes[newIndex]?.statusName === 'Not Applicable'
    ) {
      newIndex++;
    }
  } else {
    while (
      newIndex >= 0 &&
       this.listOfVolumes[newIndex]?.InvoiceValue == null || this.listOfVolumes[newIndex]?.statusName === 'Complete' || this.listOfVolumes[newIndex]?.statusName === 'Not Applicable'

    ) {
      newIndex--;
    }
  }

  if (newIndex < 0 || newIndex >= this.listOfVolumes.length) {
    return;
  }

  this.volumeDetail = this.listOfVolumes[newIndex];
  this.BindData(this.volumeDetail);
  this.currentIndex = newIndex;
}

  
  nextRecord(): void {
  if (this.currentIndex < this.listOfVolumes.length - 1) {
    this.navigateTo(this.currentIndex + 1);
  }
}

previousRecord(): void {
  if (this.currentIndex > 0) {
    this.navigateTo(this.currentIndex - 1);
  }
}
  getCurrentPositionText(): string {
  if (!this.listOfVolumes || this.listOfVolumes.length === 0) {
    return '0 of 0';
  }

  const safeIndex = this.currentIndex < 0 ? 0 : this.currentIndex;
  return `${safeIndex + 1} of ${this.listOfVolumes.length}`;
}

  pageChangeConfirmation(buttonType: number): void {
    if ((this.volumeDetailOld == JSON.stringify(this.volumeDetail))) {
      buttonType == 1 ? this.nextRecord() : this.previousRecord();
    }
    else {
      this.confirmationService.confirm({
        message: 'Changes will not be saved, Do you want to Continue?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Changes not saved',
            detail: '',
          });
          buttonType == 1 ? this.nextRecord() : this.previousRecord();
        },
        reject: () => {

        },
      });
    }
  }

  async onCancelContractVolume() {
 
      const showMessage = this.hasUnsavedChanges();
 
      const confirmed = showMessage? await this.showConfirmationMessage() : true;
 
      if(confirmed){
        this.resetManualDistributionState();
        this.resetUploadData();
        this.cancelVolumeButtonClick.emit();
      }
    }

  isSaveBtnDisable = false;
  deleteUploadedFiles: any[] = [];
  isDisabled = false;
  contractDetailId:any;
    deleteVolumeAttachment() {
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {
      });
  }
async saveContractVolume() {
  //Block repeat clicks until the save request completes, so the same month is not inserted twice
  if (this.isSaveBtnDisable) {
    return;
  }
  this.volumeSubmitted = true;
  this.isSaveBtnDisable = true;
  if (this.volumeForm.valid) {
    const productApplicable = this.volumeForm.get('productApplicable')?.value;
    const entryMethodValue = this.volumeForm.get('entryMethod')?.value;
    this.volumeDetail.entryMethod = entryMethodValue === 'Upload';

    const enteredProducts = this.filteredManualTableData
      .filter(p => p.percentage != null && p.percentage > 0)
      .map(p => ({
        volumeDate: this.datePipe.transform(this.volumeDetail.volumeDate, "yyyy-MM-dd"),
        contractDetailId: this.contractDetailId,
        volumeId: p.volumeId,
        productName: p.productName,
        productId: p.id,
        units: p.percentage,
        cost: p.cost,
        systemCalculatedCost: p.systemCalculatedCost,
        systemCalculatedUnits: p.systemCalculatedUnits,
        createdBy: p.createdBy
      }));
    const enteredUploadProducts = this.filterUploadData
      .filter(p =>
        (p.overwrittenCostAttribution != null && p.overwrittenCostAttribution > 0) ||
        (p.systemUnits != null && p.systemUnits > 0)
      )
      .map(p => ({
        volumeDate: this.datePipe.transform(this.volumeDetail.volumeDate, "yyyy-MM-dd"),
        contractDetailId: this.contractDetailId,
        volumeId: p.volumeId,
        productName: p.product,
        productId: p.productId,
        units: p.overwrittenCostAttribution,
        cost: p.overwrittenCost,
        systemCalculatedUnits: p.systemUnits,
        systemCalculatedCost: p.systemCost ? parseFloat(p.systemCost) : null,
        createdBy: p.createdBy
      }));

    let allProductsToSave: { volumeDate: string | null; contractDetailId: any; volumeId: any; productName: any; productId: any; units: any; cost: any; systemCalculatedCost: any; systemCalculatedUnits: any; createdBy: any; }[] = [];

    if (entryMethodValue === 'Manual') {
      allProductsToSave = enteredProducts;
    }
    else if (entryMethodValue === 'Upload') {
      allProductsToSave = enteredUploadProducts;
    }

    if (productApplicable === false && entryMethodValue === 'Manual') {

      const enterednonProducts = [{
        volumeDate: this.datePipe.transform(this.volumeDetail.volumeDate, "yyyy-MM-dd"),
        contractDetailId: this.contractDetailId,
        volumeId: this.volumeDetail.volumeId || 0,
        productName: 'Non Product',
        productId: 0,
        units: 100,
        cost: this.volumeDetail.invoiceAmount,
        systemCalculatedCost: null,
        systemCalculatedUnits: null,
        createdBy: this.privilegeService.getLoginUserId()
      }];

      allProductsToSave = enterednonProducts;
    }
    this.volumeDetail.financeContractVolumeProducts = allProductsToSave;
    this._contractVolumeProductsDetails = [...allProductsToSave];

    if (productApplicable === true) {
      const status = this.statusData.find((x: { name: string; }) => x.name === 'Complete');
      this.volumeDetail.statusMappingId = status?.id;
      this.volumeDetail.statusName = status?.name;
    }
    else if (productApplicable === false) {
      const status = this.statusData.find((x: { name: string; }) => x.name === 'Not Applicable');
      this.volumeDetail.statusMappingId = status?.id;
      this.volumeDetail.statusName = status?.name;
    }

    this.loaderService.showLoader();
    if (this.deleteUploadedFiles.length > 0) {
      this.deleteVolumeAttachment();
    }

    if (this.multiVolumeFileData.length > 0) {
      this._fileService.UploadMultipleFile(this.formData).subscribe({
        next: (response: any) => {
          if (response) {
            this.updateVolumeDetails();
          }
          else {
            this.loaderService.hideLoader();
            this.isSaveBtnDisable = false;
            this.messageService.add({
              key: 'tc',
              severity: 'warn',
              summary: 'Add Volume File Failed to save',
              detail: ''
            });
          }
        },
        error: () => {
          this.loaderService.hideLoader();
          this.isSaveBtnDisable = false;
        }
      })
    }
    else {
      this.updateVolumeDetails();
    }

  } else {
    this.isSaveBtnDisable = false;
    this.messageService.add({
      key: 'tc',
      severity: 'warn',
      summary: 'Please enter required information',
      detail: ''
    });
  }
}

  updateVolumeDetails() {
    this.volumeDetail.volumeDate = this.datePipe.transform(this.volumeDetail.volumeDate, "MM/dd/yyyy");
    this.volumeDetail.createdBy = this.privilegeService.getLoginUserId();
    this.volumeDetail.updatedBy = this.privilegeService.getLoginUserId();
    this.volumeDetail.financeContractVolumeAttachments = this._contractVolumeAttachmentsDetails;
    this.volumeDetail.financeContractVolumeProducts = this._contractVolumeProductsDetails
    this.volumeDetail.volumeStatus = this.statusData?.find((data: { id: any; }) => data.id == this.volumeDetail.statusMappingId)?.name;
    this.volumeDetail.productApplicability = String(this.volumeForm.get('productApplicable')?.value);
    this.volumeDetail.dataEntry=this.volumeDetail.entryMethod;
    this.financeService.UpdateContractVolume(this.volumeDetail).subscribe({
      next: async (res: any) => {
        this.isSaveBtnDisable = false;
        if (res.status) {
          this.compareModels();
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Changes have been saved',
            detail: '',
        });
          this.loaderService.hideLoader();
          this.saveVolumeButtonClick.emit();
        }
        else {
          if (res.message == 'This record is being updated by another user. Please refresh the page.') {
            this.messageService.add({
              key: 'tc',
              severity: 'warn',
              summary: res.message,
              detail: ''
            });
          }
          this.loaderService.hideLoader();
        }
      },
      error: () => {
        this.isSaveBtnDisable = false;
        this.loaderService.hideLoader();
      }
    });

  }

  downloadAttachment(data: any) {
    var attachment = this._contractVolumeAttachmentsDetails.find(attachment => attachment.fileName === data.name);

    if (attachment !== null) {
      this.downloadFile(attachment?.fileName, attachment?.filePath);
    }

  }

  async downloadFile(fileName: any, filePath: any) {
    this.auditLogService.logDownloadWithFilters('Volume Attachment',AuditIdentifier.ContractVolumes,AuditLogModule.FinanceService,fileName,{
      'Contract': this.contractName,
      'Volume Date': this.volumeDetail?.volumeDate
    });


    var fileDetail = {
      "fileName": fileName,
      "filePath": filePath
    };
    this._fileService.DownloadFile(fileDetail).subscribe(
      async (res: any) => {
        var blobData = this._fileService.dataURItoBlob(res);
        if (blobData.size > 0) {
          var response = await this._fileService.downloadBase64File(blobData, fileDetail.fileName);
          this.loaderService.hideLoader();
        }
        else {
          this.loaderService.hideLoader();

        }
      }
    );
  }

  removeFile(file: File) {
    const index = this.uploadedFiles.indexOf(file);
    this.isProcessClicked = false;
    if (index !== -1) {
      this.uploadedFiles.splice(index, 1);

      const attachmentIndex = this._contractVolumeAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
      if (attachmentIndex !== -1) {
        this._contractVolumeAttachmentsDetails.splice(attachmentIndex, 1);
      }
      this._contractVolumeAttachmentsDetails = this._contractVolumeAttachmentsDetails.map(e => {
        return this.convertKeysToUppercase(e);
      });
      var isOldVolumeAttachement = this._contractVolumeAttachmentsDetails.some(item => item.hasOwnProperty('Id'));
      if (isOldVolumeAttachement) {
        const editVolumeAttachment = this._contractVolumeAttachmentsDetails.findIndex(s => s.FileName == file.name && s.Id != 0);
        if (editVolumeAttachment !== -1) {
          var filedetails = {
            "fileName": this._contractVolumeAttachmentsDetails[editVolumeAttachment].FileName,
            "filePath": this._contractVolumeAttachmentsDetails[editVolumeAttachment].FilePath
          };
          if (filedetails.fileName != "" && filedetails.filePath != "") {
            this.deleteUploadedFiles.push(filedetails);
            this._contractVolumeAttachmentsDetails.splice(editVolumeAttachment, 1)
          }
        }
      }
      else {
        if (this._contractVolumeAttachmentsDetails) {
          const index = this._contractVolumeAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
          if (index !== -1) {
            this._contractVolumeAttachmentsDetails.splice(index, 1)
          }
        }
      }

    }
    if (this.uploadedFiles.length >= 20) {
      this.isUploadButtonDisabled = true;
    }
    else {
      this.isUploadButtonDisabled = false;
    }
    this.fileInput.nativeElement.value = '';
  }
  convertKeysToUppercase(obj: any): any {
    const convertedObject: any = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const uppercaseKey = key.charAt(0).toUpperCase() + key.slice(1);
        convertedObject[uppercaseKey] = obj[key];
      }
    }

    return convertedObject;
  }

  deleteVolumesAttachment() {
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {


      }
    );
  }

  maxFileSize: any;
  currentFileSize: any;
  uploadedFileName: any;
  allowedExtensions: any;
  uploadedVolumeFile: any;
  timeStamp: any;
onFileChange(event: any) {
  const files: FileList = event.target.files;
  this.isProcessClicked = false;

  if (files.length <= 20) {
    this.maxFileSize = this._fileService._fileSize; // 20 MB
    this.allowedExtensions = [FileExtension.XLS, FileExtension.XLSX];
    if (this.uploadedFiles.length + files.length <= 20) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const fileName = file.name;
        const fileSize = file.size;
        const extension = fileName.split('.').pop()?.trim().toLowerCase();

        if (!this.allowedExtensions.includes(extension)) {
          this.messageService.add({
            key: 'tc',
            severity: 'error',
            summary: `Invalid file type: ${fileName}`,
            detail: 'Only .xls, .xlsx files are allowed.'
          });
          continue; 
        }

        if (fileSize > this.maxFileSize) {
          this.messageService.add({
            key: 'tc',
            severity: 'error',
            summary: `File too large: ${fileName}`,
            detail: 'Max size is 20 MB'
          });
          continue; // skip this file
        }

        this.uploadedFiles.push(file);

        this.volumeForm.patchValue({
          _volumeAttachments: file.name,
        });

        this.uploadedVolumeFile = file;
        this.multiVolumeFileData.push(file);

        const utcDateTimeNow = new Date().toISOString();
        this.timeStamp = formatDate(
          utcDateTimeNow,
          this._dateformart.FiletimeStamp,
          this._dateformart.TimeStampZone
        );

        const filePath = `/Contracts/Finance/Volume/${this.timeStamp}_${file.name}`;

        this.formData.append("file", file, filePath);

        this._contractVolumeAttachments.FileName = file.name;
        this._contractVolumeAttachments.FilePath = filePath;

        this.newAttachment = {
          FileName: file.name,
          FilePath: filePath
        };

        this._contractVolumeAttachmentsDetails.push(this.newAttachment);
      }

    } else {
      this.messageService.add({
        key: 'tc',
        severity: 'error',
        summary: 'Maximum 20 files allowed.',
        detail: ''
      });
    }

  } else {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Select and upload maximum 20 files at a time.',
      detail: ''
    });
  }

  this.isUploadButtonDisabled = this.uploadedFiles.length >= 20;

  this.fileInput.nativeElement.value = '';
}
  compareModels() {
    this.changedContractVolumeBasicInfo = this.auditLogService.compareModels(JSON.parse(this.contractVolumeDetailBeforeUpdate), this.volumeDetail, this.auditEntities.ContractVolumes, this.auditIdentifierDetails.ContractVolumes, this.auditOperations.Update, this.auditModule.FinanceService);
  }

  setManualDistribution() {
    this.distributionMode = 'Manual';
    this.manualTableData.forEach(p => {
      p.percentage = null;
      p.cost = null;
    });

    this.finalizeDistribution();
  }

  private finalizeDistribution() {
    this.updateTotalPercentage();
    this.sortManualTable();
    this.filterProducts();
  }

  setEqualDistribution() {
    if (!this.manualTableData?.length || !this.totalInvoice) return;

    this.distributionMode = 'Equal';
    const totalItems = this.manualTableData.length;
    const totalInv = Number(this.totalInvoice);

    const equalCost = Number((totalInv / totalItems).toFixed(2));

    const roundingGap = Number((totalInv - (equalCost * totalItems)).toFixed(2));

    this.manualTableData = this.manualTableData.map((p, index) => {
      const isLastItem = index === totalItems - 1;
      const finalCost = isLastItem ? Number((equalCost + roundingGap).toFixed(2)) : equalCost;

      return {
        ...p,
        cost: finalCost,
        // 3. Calculate percentage based on the final cost
        percentage: this.calculatePercentage(finalCost, totalInv),
        _tempPercentage: this.calculatePercentage(finalCost, totalInv)
      };
    });

    this.finalizeDistribution();
  }

    filteredManualTableData: any[] = [];
     private setInitialState() {
 
      const productApplicable = this.volumeForm.get('productApplicable')?.value;
      const entryMethod = this.volumeForm.get('entryMethod');
 
      if (!productApplicable) {
          this.productApplicability = false;
      } else {
        this.productApplicability = true;
        entryMethod?.enable({ emitEvent: false });
        this.mode = entryMethod?.value ? 'Upload' : 'Manual';
      }
      this.previousProductApplicable = this.volumeForm.get('productApplicable')?.value;
      this.previousEntryMethod = this.volumeForm.get('entryMethod')?.value;
    }
   
  previousProductApplicable!: any;
  previousEntryMethod!: any;

   async GetProductMasterList(): Promise<void> {
      this.loaderService.showLoader();
      this.masterDataService.getMasterProducts().subscribe(res => {
 
        if (res.data && res.data.length > 0) {
          this.masterProducts = res.data.filter((p: any) => p.statusMappingId === this.sponsorStatusData?.find((s: any) => s.name === 'Active')?.id);
          const noProduct = {
            id: 0,
            productName: 'No Match or Non-Product Related',
            longName: '',
            genericName: '',
            internalName: '',
            tradeName: '',
            status: '',
            percentage: null,
            cost: null
          };

          this.manualTableData = [
            noProduct,
            ...this.masterProducts.map(p => ({
              ...p,
              percentage: null,
              cost: null
            }))
          ];
 
          this.sortManualTable();    
          this.filterProducts();    
          this.updateTotalPercentage();
        } else {
          this.manualTableData = [];
          this.filteredManualTableData = [];
          this.totalAllocatedPercentage = 0;
        }
      }, err => {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'Failed to load products',
          detail: err.message || 'Please try again'
        });
      });
    }
 
    filterProducts(): void {
      this.manualTableData.forEach(p => {p._tempPercentage = p.percentage;});
      const search = this.searchText?.trim().toLowerCase() || '';
      this.filteredManualTableData = !search ? [...this.manualTableData] : this.manualTableData.filter(p => [p.productName, p.longName, p.genericName, p.internalName, p.tradeName] .filter(Boolean).some(val => val.toLowerCase().includes(search.toLowerCase())));
      this.filteredManualTableData.sort(this.sortByAllocation);
    }  
 
    clearFilter(): void {
      this.searchText = '';
      this.filterProducts();
    }
 
    commitPercentage(rowData: any) {
 
      const value = parseFloat(rowData._tempPercentage);
 
      if (!value || value <= 0) {
        rowData.percentage = null;
        rowData.cost = null;
      } else {
        rowData.percentage = value;
        rowData.cost = this.calculateCost(value);
      }
 
      // Sync display back
      rowData._tempPercentage = rowData.percentage;
 
      this.updateTotalPercentage();
      this.sortManualTable();
 
      this.searchText = '';
      this.filterProducts();
    }  
   
 
    calculatePercentage(cost: number, totalInv: number): number {
      if (!totalInv || totalInv === 0) return 0;
     
      // Calculate percentage: (Part / Total) * 100
      const perc = (cost / totalInv) * 100;
     
      // Return rounded to 2 decimal places
      return Number(perc.toFixed(2));
    }
 
    calculateCost(percentage: number): number {
      // Ensure we are working with numbers
      const totalInv = Number(this.totalInvoice) || 0;
      const perc = Number(percentage) || 0;
     
      const calculatedCost = (perc / 100) * totalInv;
     
      // Return as a rounded Number
      return Number(calculatedCost.toFixed(2));
    }
 
    updateTotalPercentage() {
      this.totalAllocatedPercentage = this.manualTableData.reduce((sum, p) => sum + (p.percentage || 0),0);
      this.totalAllocatedPercentage = Number(this.totalAllocatedPercentage.toFixed(2));
    }
 
    sortManualTable() {
      this.manualTableData.sort(this.sortByAllocation);
    }
 
    sortByAllocation = (a: any, b: any) => {
      const aPerc = a.percentage || 0;
      const bPerc = b.percentage || 0;
 
      if (aPerc > 0 && bPerc === 0) return -1;
      if (aPerc === 0 && bPerc > 0) return 1;
 
      return bPerc - aPerc;
    };
 
    getProductDetails(product: any): string {
          if (!product) return '';
          return `Long Name : ${product.longName || '--'} ; Generic Name : ${product.genericName || '--'} ; Internal Name : ${product.internalName || '--'} ; Trade Name : ${product.tradeName || '--'}`;
    }
 
isProcessing = false;
processUploads() {

  if (!this.uploadedFiles || this.uploadedFiles.length === 0) {
    this.loaderService.hideLoader();
    this.messageService.clear('processing');
    this.messageService.add({
      key: 'tc',
      severity: 'warn',
      summary: 'No files selected',
      detail: 'Please select at least one file to upload.'
    });
    return;
  }

  this.uploadData = [];
  this.filterUploadData = [];

  const formData = new FormData();

  this.uploadedFiles.forEach((file: File) => {
    formData.append('files', file);
  });
    this.isProcessing = true;
  this.fuzzyMatchService.getFuzzyMatchResults(formData).subscribe({

    next: (res) => {

      this.isProcessClicked = true;
      this.isProcessing = false;
      const filesStatus = res?.data?.filesStatus || [];
      const results = res?.data?.results || [];

      if (results.length > 0) {
        const processedData = this.processTrackerData(results);
        setTimeout(() => {
           this.addTrackerData(processedData, results.length);
        }, 1500);
      }

      const successfulFiles = filesStatus
        .filter((f: any) => f.file_status === 'SUCCESS')
        .map((f: any) => f.filename);

      const failedFiles = filesStatus
        .filter((f: any) => f.file_status !== 'SUCCESS')
        .map((f: any) => `${f.filename} (${f.file_status})`);

      this.uploadedFiles = this.uploadedFiles.filter((file: File) =>
        successfulFiles.includes(file.name)
      );

      this.multiVolumeFileData = this.multiVolumeFileData.filter((file: File) =>
        successfulFiles.includes(file.name)
      );

      this._contractVolumeAttachmentsDetails =
        this._contractVolumeAttachmentsDetails.filter((f: any) =>
          successfulFiles.includes(f.FileName)
        );

      let messageDetail = '';

      if (successfulFiles.length > 0) {
        messageDetail += `Succeeded: ${successfulFiles.join(', ')}`;
      }

      if (failedFiles.length > 0) {
        if (messageDetail) messageDetail += '\n';
        messageDetail += `Failed: ${failedFiles.join(', ')}`;
      }

      if (successfulFiles.length > 0 && failedFiles.length === 0) {

        this.loaderService.hideLoader();
        
        this.messageService.add({
          key: 'tc',
          severity: 'success',
          summary: 'All files processed successfully',
          detail: messageDetail
        });

      }

      else if (successfulFiles.length > 0 && failedFiles.length > 0) {

        this.loaderService.hideLoader();
        
        this.confirmationService.confirm({
          message: messageDetail,
          header: 'Some Files were processed with error. Do you wish to continue',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.messageService.add({
              key: 'tc',
              severity: 'info',
              summary: 'File Data Added',
              detail: ''
            });
          },
          reject: () => {
            this.resetUploadData();
            this.messageService.add({
              key: 'tc',
              severity: 'info',
              summary: 'Changes were not saved',
              detail: ''
            });
          }
        });

      }

      else {

        this.loaderService.hideLoader();
       
        this.confirmationService.confirm({
          message: messageDetail,
          header: 'No files were successfully processed',
          icon: 'pi pi-exclamation-triangle',
          rejectVisible: false,
          acceptLabel: 'Ok',
          accept: () => {
            this.resetUploadData();
            this.messageService.add({
              key: 'tc',
              severity: 'error',
              summary: 'Error in Processing Files',
              detail: ''
            });
          }
        });

      }

    },

    error: () => {

      this.loaderService.hideLoader();
      this.isProcessing = false;
      this.messageService.add({
        key: 'tc',
        severity: 'error',
        summary: 'Server Error',
        detail: 'Something went wrong while processing files.'
      });

    }

  });

}
 
    addTrackerData(processedData: any, totalProducts: number) {
      const matchedProducts = Object.keys(processedData).map(productName => {
 
        const count = Number(processedData[productName]);
        const cost = Number((count / totalProducts) * this.totalInvoice).toFixed(2);
        
        const masterProduct = this.masterProducts.find((m: any) => m.productName === productName );

        return {
          product: productName ?? '',
          internalName: masterProduct?.internalName ?? '',
          genericName: masterProduct?.genericName ?? '',
          tradeName: masterProduct?.tradeName ?? '',
          longName: masterProduct?.longName ?? '',
          productId: masterProduct ? masterProduct.id : 0,
          systemUnits: count,
          systemCost: cost,
          overwrittenCostAttribution: null,
          overwrittenCost: null
        };
      });
 
      const matchedProductNames = new Set(Object.keys(processedData));
 
      const missingProducts = this.masterProducts
        .filter(master => !matchedProductNames.has(master.productName))
        .map(master => ({
          product: master.productName,
          internalName:master.internalName,
          genericName:master.genericName,
          tradeName:master.tradeName,
          longName:master.longName,
          productId:master.id,
          systemUnits: null,
          systemCost: null,
          overwrittenCostAttribution: null,
          overwrittenCost: null
        }));
          if (!matchedProductNames.has('No Match or Non-Product Related')) {
          missingProducts.push({
            product: 'No Match or Non-Product Related',
            internalName:'',
            genericName:'',
            tradeName:'',
            longName:'',
            productId: 0,
            systemUnits: null,
            systemCost: null,
            overwrittenCostAttribution: null,
            overwrittenCost: null
          });
        }
 
      this.uploadData = [...matchedProducts, ...missingProducts];
      this.filterUploadData = [...this.uploadData];
    }
 
    processTrackerData(trackerData: any) {
      const grouped = trackerData.reduce((acc: any, item: any) => {
      const productName = item["Mediva Product Name"];
 
      const validatedProductName = this.validateMedivaProduct(productName, item);
 
      if (!acc[validatedProductName]) {
        acc[validatedProductName] = 0;
      }
 
      acc[validatedProductName] += 1;
      return acc;
    }, {});
    return grouped;
    }
 
      threshold_match: any = 87;
    validateMedivaProduct(productName: any, item: any) {
        if(!productName || this.masterProducts.length<=0)
          return 'No Match or Non-Product Related';
 
        if(item['Match_Score']<this.threshold_match)
          return 'No Match or Non-Product Related';
 
        const matchedProduct = this.masterProducts.find(item =>
          item.productName == productName
        )
        return matchedProduct ? matchedProduct.productName : 'No Match or Non-Product Related';
    }
 
    commitUploadPercentage(rowData: any) {
 
      const value = parseFloat(rowData.overwrittenCostAttribution) || 0;
 
      if (value <= 0) {
        rowData.overwrittenCostAttribution = null;
        rowData.overwrittenCost = null;
      } else {
        rowData.overwrittenCost =Number(this.calculateCost(value).toFixed(2));
      }
 
      this.totalOverridePercentage = this.uploadData.reduce(
        (sum, item) => sum + (parseFloat(item.overwrittenCostAttribution) || 0),0);
      this.totalOverridePercentage = Number(this.totalOverridePercentage.toFixed(2))
      this.uploadData = this.sortUploadData(this.uploadData);
      this.clearUploadFilter();
     
    }
 
    async changeProductApplicable(value: any){
 
      if (this.productApplicability === value) {
        return;
      }
 
      if(value === true){
        this.volumeForm.get('entryMethod')?.setValue(this.mode);
        this.productApplicability = true;
      } else {
        const isChanged = this.hasUnsavedChanges();
        if(isChanged){
          const confirmChange = await this.showConfirmationMessage();
          if(confirmChange){
            this.productApplicability = false;
            this.resetManualDistributionState();
            this.resetUploadData();
            this.isOverrideEnabled = false;
          }
          else{
            this.productApplicability = true;
            this.volumeForm.get('productApplicable')?.setValue(true);
          }
        }
        else{
            this.productApplicability = false;
        }
      }
    }
 
    async changeEntryMethod(value: any){
      if(this.mode === value)
        return;
      const hasUnsavedChanges = this.hasUnsavedChanges();
 
      if(hasUnsavedChanges){
        const confirmChange = await this.showConfirmationMessage();
        if(confirmChange){
          this.mode = value;
          this.resetManualDistributionState();
          this.resetUploadData();
          this.isOverrideEnabled = false;
        } else {
          this.volumeForm.get('entryMethod')?.setValue(this.mode);
        }
      } else {
        this.mode = value;
      }
     
    }
 
    private showConfirmationMessage(): Promise<boolean> {
      return new Promise((resolve) => {
        this.confirmationService.confirm({
          message: 'If you change, your entries will be lost and not saved. Do you want to continue?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Yes',
          rejectLabel: 'No',
          accept: () => resolve(true),
          reject: () => resolve(false)
        });
      });
    }
 
     async onOverrideChange() {
      if (!this.isOverrideEnabled) {
        const hasOverrideChanges =
        this.uploadData?.some(row =>
          row.overwrittenCostAttribution != null ||
          row.overwrittenCost != null
        );
        if(hasOverrideChanges){
          const confirmed = await this.showConfirmationMessage();
            if(confirmed){
           
              this.uploadData.forEach(product => {
                product.overwrittenCostAttribution = null;
                product.overwrittenCost = null;
              });
           
              this.totalOverridePercentage = 0;
            }
            else {
              this.isOverrideEnabled = !this.isOverrideEnabled;
            }
        }
      }
    }
 
    private resetManualDistributionState() {
      this.manualTableData.forEach(p => {
        p.percentage = null;
        p._tempPercentage = null;
        p.cost = null;
      });
 
      this.totalAllocatedPercentage = 0;
 
      this.sortManualTable();
      this.filterProducts();
    }
 
    private resetUploadData() {
 
      this.uploadData = [];
      this.filterUploadData = [];
 
      this.uploadedFiles = [];
      this.multiVolumeFileData = [];
 
      this._contractVolumeAttachmentsDetails = [];
 
      this.formData = new FormData();
 
      this.isProcessClicked = false;
 
      this.volumeForm.patchValue({
        _volumeAttachments: '',
        _volumeFileName: '',
        _volumeFile: ''
      });
 
      this.totalOverridePercentage = 0;
 
      this.isUploadButtonDisabled = false;
    }
 
    filterUploadProducts() {
      const search = (this.searchText || '').trim().toLowerCase();

      this.filterUploadData = search ? this.uploadData.filter(p =>
            [p.product, p.longName, p.genericName, p.internalName, p.tradeName].filter(Boolean).some(val => val.toLowerCase().includes(search.toLowerCase()))) : [...this.uploadData];
            this.table.first=0;
    }
 
    clearUploadFilter() {
          this.searchText = '';
          this.filterUploadData = [...this.uploadData];

    }
 
    sortUploadData(data: any[]): any[] {
 
      return [...data].sort((a, b) => {
 
        const aUnits = a.systemUnits ?? -Infinity;
        const bUnits = b.systemUnits ?? -Infinity;
 
        if (aUnits !== bUnits) {
          return bUnits - aUnits;
        }
 
        const aOverwrite = a.overwrittenCostAttribution ?? -Infinity;
        const bOverwrite = b.overwrittenCostAttribution ?? -Infinity;
 
        if (aOverwrite !== bOverwrite) {
          return bOverwrite - aOverwrite;
        }
 
        return (a.product || '').localeCompare(b.product || '');
      });
    }
 
    uploadData: any[] = [];
    filterUploadData: any[] = [];
    hasUnsavedChanges(){
      const hasUploadData = this.uploadData.length != 0;
 
      const hasOverrideChanges =
        this.uploadData?.some(row =>
          row.overwrittenCostAttribution != null ||
          row.overwrittenCost != null
        );
 
 
      const hasManualChanges =
        this.manualTableData?.some(row =>
          row._tempPercentage != null
        );
 
      const hasUploadedFiles = this.uploadedFiles.length != 0;
 
      if(hasManualChanges||hasOverrideChanges||hasUploadedFiles||hasUploadData){
        return true;
      }
      return false;
    }
 
    sponsorStatusData:any;
     GetsponserStatus(){
    this.masterDataService.getCodeListData(3,'Sponser').subscribe(
      data=>{
        this.sponsorStatusData=data.data;
       }
    );
   
  }
 

}
